import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, Subscription } from 'rxjs';
import { CurrentContextService } from '../../core/context/current-context.service';
import { LiveUpdateEventTypes, workflowOperationsTopic } from '../../core/live-updates/live-update.models';
import { LiveUpdateService } from '../../core/live-updates/live-update.service';

export type WorkflowLiveUpdatesDeps = {
  liveUpdateService: LiveUpdateService;
  contextService: CurrentContextService;
  destroyRef: DestroyRef;
};

export function bindWorkflowTaskLiveUpdates(
  deps: WorkflowLiveUpdatesDeps,
  reload: (showLoading?: boolean) => void,
  taskId?: string | null | (() => string | null | undefined)
): void {
  const { liveUpdateService, contextService, destroyRef } = deps;
  const subscriptionState = { topic: '' };

  const subscription: Subscription = liveUpdateService.events$
    .pipe(
      filter(event => {
        if (event.eventType !== LiveUpdateEventTypes.workflowTasksChanged) {
          return false;
        }

        const currentTaskId = typeof taskId === 'function' ? taskId() : taskId;
        if (!currentTaskId) {
          return true;
        }

        const payloadTaskId = event.payload['taskId'];
        return payloadTaskId === undefined || payloadTaskId === currentTaskId;
      }),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe(() => reload(false));

  destroyRef.onDestroy(() => {
    subscription.unsubscribe();
    if (subscriptionState.topic) {
      void liveUpdateService.unsubscribe(subscriptionState.topic);
    }
  });

  const tenantId = contextService.context()?.tenantId;
  if (tenantId) {
    subscriptionState.topic = workflowOperationsTopic(tenantId);
    void liveUpdateService.subscribe(subscriptionState.topic);
  }
}
